import * as THREE from 'three'
import Experience from '../experience.js'

const REPEAT_WRAP = 64;

export default class Ground {

    constructor() {
        this.experience = new Experience();
        this.scene = this.experience.scene;
        this.textureLoader = this.experience.textureLoader;

        this.debugFolder = this.experience.gui.addFolder('Ground');
        this.debugFolder.close();

        this.setModel();
    }

    setModel() {
        const displacementTexture = this.textureLoader.load('./textures/grass/displacementMap.jpg')
        const grassColorTexture = this.textureLoader.load('./textures/grass/color.jpg')
        const grassNormalTexture = this.textureLoader.load('./textures/grass/normal.jpg')

        grassColorTexture.colorSpace = THREE.SRGBColorSpace
        grassColorTexture.repeat.set(REPEAT_WRAP, REPEAT_WRAP)
        grassNormalTexture.repeat.set(REPEAT_WRAP, REPEAT_WRAP)

        grassColorTexture.wrapS = THREE.RepeatWrapping;
        grassNormalTexture.wrapS = THREE.RepeatWrapping;
        grassColorTexture.wrapT = THREE.RepeatWrapping;
        grassNormalTexture.wrapT = THREE.RepeatWrapping;

        const material = new THREE.MeshStandardMaterial({
            map: grassColorTexture,
            normalMap: grassNormalTexture,
            displacementMap: displacementTexture
        });
        material.displacementScale = 50.0
        material.roughness = 0.95;
        this.debugFolder.add(material, 'displacementScale').min(0).max(150).step(0.01).name('Displacement Scale');
        this.debugFolder.add(material, 'roughness').min(0).max(1).step(0.001).name('Roughness');

        const floor = new THREE.Mesh(
            new THREE.PlaneGeometry(640, 640, 128, 128),
            material 
        )
        floor.rotation.x = - Math.PI * 0.5
        floor.position.y = 0
        floor.receiveShadow = true
        this.scene.add(floor)
    }


    update() {
        // Shader does all the work
    }
}